import { toast } from "react-toastify"
import { TypeOptions } from "react-toastify/dist/types"

export const notify = (type: TypeOptions, message: string) => {
  const not = toast as any
  not[type](message)
}

export const notifyError = (error: Error) => {
  notify('error', error.message)
}